export const FINOPS_EXEC_COST_ROLES = ['D&AI Executive User', 'D&AI Executive', 'D&AI User', 'D&AI Admin', 'Program Executive', 'FinOps Full Access'];
export const FINOPS_USER_ROLES = ['FinOps User', 'FinOps Full Access'];
export const FINOPS_ALL_ROLES = [...FINOPS_EXEC_COST_ROLES, ...FINOPS_USER_ROLES];
